module.exports = __webpack_public_path__ + "static/head-coach-9c5d30767b6e03babb148b9429123c4f.svg";